import React from "react";
import { useScroll, useTransform, motion } from "framer-motion";
import bg1 from "../assets/bg4.jpg";
import bg2 from "../assets/banner.jpg";
import landingbefore from "../assets/kc1.jpg";
import landingafter from "../assets/kc2.jpg";
import br1 from "../assets/br1.png";
import br2 from "../assets/br2.png";
import beforelanding from "../assets/beforelanding.jpg";
import afterlanding from "../assets/afterlanding.jpg";
import CompareImage from "react-compare-image";
import { FaFacebook, FaHouse, FaInstagram } from "react-icons/fa6";
import fulllogo from "../assets/fulllogo.jpg";

const Home = () => {
  const { scrollY } = useScroll();
  const y1 = useTransform(scrollY, [0, 1000], [0, 0], { clamp: false });

  return (
    <div className="text-center jost">
      <motion.div
        className="relative h-screen bg-cover bg-center"
        style={{ backgroundImage: `url(${bg1})`, y: y1 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-30 flex flex-col justify-center items-center sm:items-start sm:pl-32 sm:pr-10 sm:py-20">
          <img
            src={fulllogo}
            alt="Fixit Handyman Home Services LLC Logo"
            className="h-24 mr-2 rounded-none pb-4 sm:h-0"
          />
          <h1 className="text-[#fcc11b] text-4xl md:text-6xl font-bold text-center sm:text-left mr-2 sm:pr-3 pb-2">
            Fixit Handyman Home Services LLC
          </h1>
          <h3 className="text-[#fcc11b] text-xl md:text-2xl pr-2 mb-4 text-center sm:text-left">
            we make your dream home
          </h3>
          <motion.div
            whileHover={{
              scale: 1.1,
              translateZ: 50,
              perspective: 1000,
              boxShadow: "0px 20px 30px rgba(0, 0, 0, 0.4)",
              transition: { duration: 0.2 },
            }}
            className="inline-block mb-4 text-center sm:text-left"
          >
            <a
              href="tel:+12065308861"
              className="bg-[#fcc11b] text-[#000000] px-4 py-2 rounded font-bold flex items-center space-x-1 text-lg md:text-xl"
            >
              <span>📞</span>
              <span>(206) 530 8861</span>
            </a>
          </motion.div>
        </div>
      </motion.div>

      <div className="relative h-auto sm:pt-16 bg-[#000000] sm:pb-6">
        <h1 className="text-4xl font-bold text-center pt-4 sm:pt-0 bg-gradient-to-r to-[#fcc11b] from-white bg-clip-text text-transparent">
          {" "}
          Slide to view before & after
        </h1>
        <div className="flex flex-col sm:flex-row justify-center items-center w-full space-y-6 sm:space-y-0 sm:space-x-6 p-6 sm:p-10">
          <div className="flex flex-col items-center w-full sm:w-1/2">
            <div className="w-4/5">
              <CompareImage
                leftImage={landingbefore}
                rightImage={landingafter}
              />
            </div>

            <div className="flex flex-row items-center mt-4 space-x-2">
              <FaHouse className="text-[#fcc11b]"></FaHouse>
              <span className="text-lg text-[#fcc11b]">
                Kitchen Renovation
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center w-full sm:w-1/2">
            <div className="w-4/5">
              <CompareImage
                leftImage={beforelanding}
                rightImage={afterlanding}
              />
            </div>
            <div className="flex flex-row items-center mt-4 space-x-2">
              <FaHouse className="text-[#fcc11b]"></FaHouse>
              <span className="text-lg text-[#fcc11b]">
                Foyer Refurbishment
              </span>
            </div>
          </div>
          <div className="flex flex-col items-center w-full sm:w-1/2">
            <div className="w-4/5">
              <CompareImage leftImage={br1} rightImage={br2} />
            </div>
            <div className="flex flex-row items-center mt-4 space-x-2">
              <FaHouse className="text-[#fcc11b]"></FaHouse>
              <span className="text-lg text-[#fcc11b]"> Bathroom Remodel</span>
            </div>
          </div>
        </div>
        <motion.div
          whileHover={{
            scale: 1.1,
            translateZ: 50,
            perspective: 1000,
            boxShadow: "0px 20px 30px rgba(0, 0, 0, 0.4)",
            transition: { duration: 0.2 },
          }}
          className="inline-block text-center text-md sm:text-left"
        >
          <a
            href="/gallery"
            className="bg-[#fcc11b] text-[#000000] px-4 py-2 rounded font-bold flex items-center space-x-2 text-md md:text-xl"
          >
            <FaHouse />
            <span>View Other Work</span>
          </a>
        </motion.div>
      </div>

      <div className="relative h-auto sm:py-16 bg-[#7A918D]">
        <div className="flex flex-col-reverse sm:flex-row justify-center items-start sm:space-x-8 px-6 sm:px-20">
          <div className="relative flex flex-col sm:w-1/2 mt-8 sm:mt-0 space-y-4 order-2 sm:order-1">
            <div className="absolute top-0 left-0 w-full h-[2px] bg-[#fcc11b] sm:mt-2"></div>
            <div className="relative pt-6 sm:pt-4 pl-4 sm:pl-0">
              <h1 className="text-[#000000] text-4xl font-bold text-left pb-0 py-8 underline underline-offset-2">
                Why Us?
              </h1>
              <div className="text-left text-[#fcc11b] font-bold text-xl pt-4">
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  Looking for reliable and fast handyman services? Fixit
                  Handyman specializes in quick turnarounds, quality work, and
                  dependable results you can count on. Perfect for touch-ups,
                  repairs, or remodeling needs. Licensed, bonded, insured, and
                  trusted by many! Contact us today for a hassle-free
                  experience!
                </motion.div>
              </div>

              <p className="text-[#fcc11b] text-2xl mt-4 pb-10 sm:pb-0 text-left">
                <div className="text-[#000000] text-2xl font-bold text-left pb-2 py-8">
                  Fixit Handyman Home Services LLC offers the following
                  services:
                </div>
                <div className="space-y-2">
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5 }}
                    className="text-[#fcc11b] text-xl font-semibold flex items-center"
                  >
                    🌟 General Contracting
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6 }}
                    className="text-[#fcc11b] text-xl font-semibold flex items-center"
                  >
                    🌟 Accessory Building Construction
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.7 }}
                    className="text-[#fcc11b] text-xl font-semibold flex items-center"
                  >
                    🌟 Bathroom Remodeling
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    className="text-[#fcc11b] text-xl font-semibold flex items-center"
                  >
                    🌟 Kitchen Remodeling
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.9 }}
                    className="text-[#fcc11b] text-xl font-semibold flex items-center"
                  >
                    🌟 Basement Remodeling
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.0 }}
                    className="text-[#fcc11b] text-xl font-semibold flex items-center"
                  >
                    🌟 Deck and Outdoor Pergola Construction
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.1 }}
                    className="text-[#fcc11b] text-xl font-semibold flex items-center"
                  >
                    🌟 Exterior and Interior Painting
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.2 }}
                    className="text-[#fcc11b] text-xl font-semibold flex items-center"
                  >
                    🌟 Roof Works
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.3 }}
                    className="text-[#fcc11b] text-xl font-semibold flex items-center"
                  >
                    🌟 Assembling and Installation
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.4 }}
                    className="text-[#fcc11b] text-xl font-semibold flex items-center"
                  >
                    🌟 Plumbing and Electrical Troubleshooting
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.5 }}
                    className="text-[#fcc11b] text-xl font-semibold flex items-center"
                  >
                    🌟 Home Repairs
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.6 }}
                    className="text-[#fcc11b] text-xl font-semibold flex items-center"
                  >
                    🌟 And More...
                  </motion.div>
                </div>

                <div className="flex justify-start mt-6">
                  <motion.div
                    whileHover={{
                      scale: 1.1,
                      translateZ: 50,
                      perspective: 1000,
                      boxShadow: "0px 20px 30px rgba(0, 0, 0, 0.4)",
                      transition: { duration: 0.2 },
                    }}
                    className="inline-block"
                  >
                    <a
                      href="https://www.facebook.com/profile.php?id=100087216231259&rdid=mJAv25QiFNIyB8bH&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F15TM46zeRW%2F#"
                      className="bg-[#fcc11b] text-[#000000] px-6 py-3 rounded font-bold flex items-center space-x-2 text-md md:text-xl"
                    >
                      <FaFacebook className="pr-1" />
                      <span>View Facebook</span>
                    </a>
                  </motion.div>
                </div>
              </p>
            </div>
          </div>
          <div className="relative flex flex-col w-full sm:w-1/2 space-y-4 sm:space-y-0 sm:space-x-4 order-1 sm:order-2">
            <motion.div
              className="relative w-full"
              whileHover={{ scale: 1.05, transition: { duration: 0.3 } }}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <img
                src={bg2}
                alt="Image 1"
                className="h-full w-auto object-cover p-2"
                style={{ zIndex: 1 }}
              />
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
